module.exports = __webpack_public_path__ + "static/media/ich.dd3ca24b.jpg";